<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="booking-container">
                <div v-if="isLoading" class="d-flex justify-content-center">
                    <loader></loader>
                </div>
                <div v-else>

                
                    <div class="row d-flex justify-content-center mb-4">
                        <div class="col-12 text-center ">
                            <h2 class="mb-4">Choose an arrival time?</h2>
                        </div>
                    </div>
                    <div v-if="guests.length > 1" class="row justify-content-center">
                        <div class="row justify-content-center">
                            <div class="col-24 col-xl-12 d-flex justify-content-center">
                                <div class="mb-4 bg-white  p-3 ">
                                    <label class="same-time">
                                        <input class="stacked-option" type="checkbox" v-model="showStacked" v-on:click="combinedSelected = null;" />
                                        Start all guest's days at the same time
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-2" v-if="!showStacked">
                    <div v-for="(guest, gIndex) in guests" class="col-24 col-xl-12">
                        <div class="row mb-4">
                            <div class="col-24 text-center">
                                <h3>{{guest.firstName}}</h3>
                            </div>
                        </div>
                        <div class="px-4">
                            <div class="row">
                                <div v-for="(arrivalTime, tImedex) in arrivalTimes"
                                     class="col-24  mb-2">
                                    <button class="btn btn--block time-slot "
                                            v-on:click="onClick(guest, arrivalTime, gIndex)"
                                            v-bind:class="{'time-slot--active': isSelected(guest, arrivalTime), 'timeslot--disabled' : isDisabled(arrivalTime)}">
                                        {{arrivalTime.time}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-2 justify-content-center" v-else>
                    <div class="px-4 col-24 col-xl-12">
                        <div class="row mb-4">
                            <div class="col-24 text-center">
                                <h3>Arrival Time</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div v-for="(arrivalTime, tImedex) in arrivalTimes"
                                 class="col-24  mb-2">

                                <button class="btn btn--block time-slot "
                                        v-on:click="onCombinedClick(arrivalTime)"
                                        v-bind:class="{'time-slot--active': isCombinedSelected(arrivalTime), 'timeslot--disabled' : isCombinedDisabled(arrivalTime)}">
                                    {{arrivalTime.time}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <actions-bar>
        <template v-slot:actions>
            <div class="row">
                <div class="col-10">

                    <button v-on:click="onBack"
                            type="button"
                            class="btn btn--transparent btn--back">
                        Back
                    </button>
                </div>

                <div class="col-4 d-flex flex-column align-items-center">

                    <span v-if="total > 0" class="spa-total-label">Total</span>
                    <span v-if="total > 0" class="spa-total">&pound;{{total}}</span>

                </div>

                <div class="col-10 d-flex justify-content-end">
                    <button class="btn btn--slate-blue btn--continue"
                            v-bind:disabled="!canSubmit"
                            type="button"
                            v-on:click="onContinue()">
                        Next

                    </button>
                </div>
            </div>
        </template>
    </actions-bar>



</template>

<script>
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';
    import { store } from '../store/index';
    export default {
        name: 'SpaDayArrivalTme',

        components: {

            ActionsBar,
            Loader

        },

        mounted() {

            this.isLoading = false;

            let guests = [];
            for (let guestIndex = 0; guestIndex < this.search.guestCount; guestIndex++) {
                let guest = this.search.guests[guestIndex];
                guests.push({ title: guest.title, firstName: guest.firstName, lastName: guest.lastName, isLoggedInUser: guest.isLoggedInUser, arrivalTime: null })
            }

            this.guests = guests;



            this.isLoading = false;
        },
        data() {
            return {
                isLoading: false,
                guests: [],
                showStacked: true,
                combinedSelected: null

            }
        },
        computed: {
            facilities() {
                return store.getters.facilities;
            },
            arrivalTimes() {
                let spaTimes = this.search.spaDay.BandTimes;

                let allowedArrivals = this.facilities?.find(item => item.key == 'Spa Arrival')?.items;
         
                var result = [];
                for (let i = 0; i < spaTimes.length; i++) {
                    let spaTime = spaTimes[i];
                    var asTime = moment(spaTime, "HH:mm:ss");

                    var arrivals = allowedArrivals.find(i => moment(i.key).format("HH:mm") == asTime.format("HH:mm"));

                 
                    result.push({ time: asTime.format("HH:mm"), items : arrivals, isAvailable: arrivals.length > 0, isAllAvailable: arrivals.length >= this.search.guests.length });
                }

                return result;
            },
            canSubmit() {
                let aGuests = this.guests.filter(item => item.arrivalTime == null);
                return aGuests.length == 0;
            },

            session() {
                return store.getters.session
            },
            search() {
                return store.getters.search;
            },
            booking() {
                return store.getters.booking;
            },
            total() {
                return store.getters.dayTotal
            }
        },
        methods: {
            onBack() {
                this.$router.push({ name: 'spa_day_guests', params: { id: this.session.Id } });

            },
            onContinue() {
                let payload = this.guests;
                store.dispatch("setGuestTimes", payload).then(() => {

                    if (this.search.spaDay.HasDining) {
                        this.$router.push({ name: 'spa_day_dining', params: { id: this.session.Id } });
                    }

                    else if (this.search.spaDay.HasSpaGarden) {
                        this.$router.push({ name: 'spa_day_garden', params: { id: this.session.Id } });
                    }
                    else if (this.search.spaDay.HasTreatments) {
                        this.$router.push({ name: 'spa_day_treatments', params: { id: this.session.Id } });
                    }
                    else if (this.search.spaDay.HasExtras) {
                        this.$router.push({ name: 'spa_day_add_ons', params: { id: this.session.Id } });
                    }
                    else {
                        this.$router.push({ name: 'spa_day_details', params: { id: this.session.Id } });
                    }
                });
            },
            onClick(guest, time, guestIndex) {
         
                time.selectedItem = time.items.items[0];
                guest.arrivalTime = time;
            },
            onCombinedClick(time) {
                this.combinedSelected = time;
                for (let gi = 0; gi < this.guests.length; gi++) {
                    let guest = this.guests[gi];
                    this.onClick(guest, time, gi);
                }
            },
            isSelected(guest, arrivalTime) {
                return guest.arrivalTime?.time == arrivalTime.time;
            },
            isDisabled() {

                return true;
            },
            isCombinedSelected(arrivalTime) {
                return this.combinedSelected?.time == arrivalTime.time;
            },
            isCombinedDisabled() {

                return true;
            },
        }
    }
</script>

<style scoped>
    .time-slot {
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        cursor: pointer !important;
        border: none;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }

    .stacked-option {
        width: 20px;
        height: 20px;
        top: 3px;
        position: relative;
        margin-right: 5px;
    }

    .same-time {
        cursor: pointer !important;
    }
</style>